import { atom } from "recoil";

const apiDataAtom = atom({
    key: 'apiDataAtom', 
    default: null, 
});

export default apiDataAtom;